export function buildCheckoutReturnUrl(
  currentUrl: string,
  subscriptionId: string,
): string {
  const url = new URL(currentUrl);
  for (const key of ["email", "promo", "promo_code", "step", "paywall"])
    url.searchParams.delete(key);
  url.searchParams.set("subscription_id", subscriptionId);
  url.hash = "checkout_complete";
  return url.toString();
}

export function buildWatchReturnUrl(
  currentUrl: string,
  subscriptionId: string,
  token: string,
) {
  if (!/^[a-f0-9]{64}$/.test(token))
    throw new Error("Missing checkout receipt");
  const url = new URL(buildCheckoutReturnUrl(currentUrl, subscriptionId));
  url.hash = `checkout_complete&claim=${token}`;
  return url.href;
}
